import React, { useState } from 'react';
import PreviewCanvas from './PreviewCanvas';
import AiBanner from './AiBanner';
import { useBlockApply } from './useBlockApply';
import './effectBlocks.css';

/**
 * FadeBlockEditor — panel block: fade in or out over a duration -> fade_tool.
 */
function FadeBlockEditor({ videoWorkspaceId, frameUrl, sourceFileName, mediaInfo, aiSuggestion, onApplied, onClose }) {
    const { setMeasured, aspectRatio, ready, applying, error, apply } =
        useBlockApply({ videoWorkspaceId, sourceFileName, mediaInfo });
    const [fadeType, setFadeType] = useState(aiSuggestion?.params?.fadeType || 'in');
    const [duration, setDuration] = useState(Number(aiSuggestion?.params?.duration) || 1);

    return (
        <div className="eb-editor">
            <AiBanner rationale={aiSuggestion?.rationale} />
            <div className="eb-editor-grid">
                <PreviewCanvas
                    frameUrl={frameUrl}
                    isVideo
                    aspectRatio={aspectRatio}
                    blocks={[]}
                    onMeta={setMeasured}
                    onSelect={() => {}}
                    onChange={() => {}}
                />
                <div className="eb-controls">
                    <h5>Fade</h5>
                    <div className="eb-ctl">
                        <span>Type</span>
                        <div className="eb-seg">
                            <button type="button" aria-pressed={fadeType === 'in'} onClick={() => setFadeType('in')}>Fade in</button>
                            <button type="button" aria-pressed={fadeType === 'out'} onClick={() => setFadeType('out')}>Fade out</button>
                        </div>
                    </div>
                    <label className="eb-ctl">
                        <span>Duration <em>{duration}s</em></span>
                        <input type="range" min="0.2" max="4" step="0.1" value={duration} onChange={(e) => setDuration(Number(e.target.value))} />
                    </label>
                    <p className="eb-hint">{fadeType === 'in' ? 'Fades up from black at the start.' : 'Fades to black at the end.'}</p>

                    {error && <p className="eb-error">{error}</p>}

                    <div className="eb-actions">
                        {onClose && <button type="button" className="eb-btn" onClick={onClose}>Cancel</button>}
                        <button
                            type="button"
                            className="eb-btn primary"
                            disabled={!ready || applying}
                            onClick={() => apply({ type: 'fade', params: { fadeType, duration } }, onApplied)}
                        >
                            {applying ? 'Applying…' : 'Add to timeline'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FadeBlockEditor;
